export const sendMetaConversionEvent = async ({
    eventName,
    eventData,
    eventId = crypto.randomUUID(),
    testEventCode
  }: {
    eventName: string;
    eventData: Record<string, unknown>;
    eventId?: string;
    testEventCode?: string;
  }) => {
    try {
      const res = await fetch('/api/meta-conversion', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          eventName,
          eventData,
          eventId,
          testEventCode,
        }),
      });
  
      if (!res.ok) {
        console.error(`Failed to send ${eventName} event to Meta Conversion API`);
      }
  
      return res;
    } catch (err) {
      console.error("Error sending Meta Conversion event:", err);
    }
  };